const Tickets = {
  ticketsPath: () => `/api/tickets`,
  getAllTickets: () => `/Agency/v2/GetTickets`,
  getDetailsTickets: () => `/Agency/GetTicketDetails`,
  getCompanies: () => `/Company`,
};

export default Tickets;
